/**
 * @generated SignedSource<<c5f7334a37d9aa7fd3599d2469bbcf5a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChildrenPreferencesMultiSelectInput_query$data = {
  readonly childrenPreferences: {
    readonly nodes: ReadonlyArray<{
      readonly name: string;
      readonly rowId: any;
    } | null | undefined>;
  } | null | undefined;
  readonly " $fragmentType": "ChildrenPreferencesMultiSelectInput_query";
};
export type ChildrenPreferencesMultiSelectInput_query$key = {
  readonly " $data"?: ChildrenPreferencesMultiSelectInput_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChildrenPreferencesMultiSelectInput_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChildrenPreferencesMultiSelectInput_query",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": [
            "SEQUENCE_ASC"
          ]
        }
      ],
      "concreteType": "ChildrenPreferenceConnection",
      "kind": "LinkedField",
      "name": "childrenPreferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ChildrenPreference",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rowId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "childrenPreferences(orderBy:[\"SEQUENCE_ASC\"])"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "fa17ad5fb5b31104b466ab219e64d6e8";

export default node;
